import { createElement, FC, HTMLProps } from 'react';
import cx from 'classnames';

import './styles.scss';

export interface IButtonProps extends HTMLProps<HTMLButtonElement> {
	tag?: 'a' | 'div';
	primary?: boolean;
	secondary?: boolean;
	rounded?: boolean;
}

export const Button: FC<IButtonProps> = ({
	type,
	tag,
	className,
	primary,
	secondary,
	rounded,
	children,
	...props
}) => {
	return createElement(
		tag || 'button',
		{
			...props,
			className: cx(
				'button',
				{
					'button-primary': primary,
					'button-secondary': secondary,
					'button-rounded': rounded,
				},
				className,
			),
			...(!tag ? { type } : {}),
		},
		children,
	);
};
